"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _utils = _interopRequireDefault(require("../../utils"));

var _colors = _interopRequireDefault(require("../../colors"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    height: ", ";\n    width: ", ";\n    border: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SvgIconStripped = function SvgIconStripped(_ref) {
  var rounded = _ref.rounded,
      indeterminate = _ref.indeterminate,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["rounded", "indeterminate"]);
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props);
};

var SvgIcon = (0, _styledComponents["default"])(SvgIconStripped)(_templateObject(), function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return "".concat(props.width, "px");
}, "1px solid rgba(".concat(_utils["default"].hexToRGB(_colors["default"].blackberry[700]), ", 0.2)"), function (props) {
  return props.rounded ? '50%' : '4px';
}, function (props) {
  if (props.disabled || props.indeterminate) {
    return _colors["default"].lychee[700];
  }

  if (props.checked) {
    return _colors["default"].liva[400];
  }

  return _colors["default"].lychee[100];
});
exports.SvgIcon = SvgIcon;
var _default = {
  SvgIcon: SvgIcon
};
exports["default"] = _default;